import PropTypes from 'prop-types';
import { useMounted } from '../../hooks/useMounted';

/**
 * Renderiza children solo en el cliente, después de la hidratación.
 * Durante el prerenderizado (Puppeteer) y el primer render de hidratación
 * ambos devuelven `fallback` (null por defecto), garantizando que no haya
 * hydration mismatch para componentes con lógica async o dependientes de window.
 */
export default function ClientOnly({ children, fallback = null }) {
  const mounted = useMounted();
  return mounted ? children : fallback;
}

ClientOnly.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};
